import Breakpoint from 'bootstrap-breakpoints'
import constants from './constants'
import { Tooltip } from 'bootstrap'

export const getData = (objName) => {
  return typeof window[objName] !== 'undefined' ? window[objName] : null
}

export const getHTMLData = (obj, datastr, defVal) => {
  let str = ''
  if (typeof defVal !== 'undefined') str = defVal
  if (typeof obj.data(datastr) !== 'undefined') str = obj.data(datastr)
  return str
}

export const viewport = function () {
  let e = window,
    a = 'inner'
  if (!('innerWidth' in window)) {
    a = 'client'
    e = document.documentElement || document.body
  }
  return { width: e[`${a}Width`], height: e[`${a}Height`] }
}

export const setViewportName = () => {
  const v = viewport()

  constants.windW = v.width
  constants.windH = v.height

  if (v.width > 1278) {
    constants.is = 'desktop'
  } else if (v.width > 768) {
    constants.is = 'tablet'
  } else {
    constants.is = 'mobile'
  }
}

export const randomNumber = (length = 10) => {
  let result = ''
  const characters = '0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    // prettier-ignore
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const scrollToError = (offsetY = constants.scrollToAlertOffset) => {
  const elements = jQuery('.alert').first()

  moveWindowToObj(elements, offsetY)
}

export const scrollToValidation = (offsetY = constants.scrollToAlertOffset) => {
  // prettier-ignore
  const elements = jQuery('.form-control--error, .form-select--error').first()

  moveWindowToObj(elements, offsetY)
}

export const scrollToTop = () => {
  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: jQuery('html').offset().top,
    },
    500,
    'linear'
  )
}

export const scrollToElem = (elem, offsetY = 0) => {
  if (!elem.length) {
    return
  }

  jQuery([document.documentElement, document.body]).animate(
    {
      scrollTop: elem.offset().top - offsetY,
    },
    500
  )
}

export const hasValue = (val) => {
  return typeof val !== 'undefined' && val !== null && val !== ''
}

export const getUrlParam = (parameter, defaultValue) => {
  const searchParams = new URL(window.location.href).searchParams

  for (const [key, value] of searchParams.entries()) {
    if (key === parameter) {
      return value
    }
  }

  return defaultValue
}

export const appendUrlParam = (parameter, value) => {
  const url = new URL(window.location.href)

  const searchParams = url.searchParams

  urlParamExists(parameter)
    ? searchParams.set(parameter, value)
    : searchParams.append(parameter, value)

  history.pushState({}, null, url)
}

export const appendUrlParams = (parameters, values) => {
  const url = new URL(window.location.href)
  const searchParams = url.searchParams

  parameters.forEach((i, index) => {
    urlParamExists(i)
      ? searchParams.set(i, values[index])
      : searchParams.append(i, values[index])
  })

  history.pushState({}, null, url)
}

export const urlParamExists = (field) => {
  const url = window.location.href
  if (url.indexOf(`?${field}=`) !== -1) return true
  else if (url.indexOf(`&${field}=`) !== -1) return true
  return false
}

export const isNumber = (evt) => {
  const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const keyPressed = evt.key

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault()
  }
}

export const getPrevalueText = (array, value) => {
  const entry = array.find((i) => i.value === value)

  return entry ? entry.text : ''
}

export const fileTypeIsJpeg = (value) => {
  return value === constants.fileTypes.jpeg
}

export const fileTypeIsPdf = (value) => {
  return value === constants.fileTypes.pdf
}

export const roundValueByInterval = (value, interval) => {
  const modulo = value % interval
  const intervalHalf = interval / 2

  if (modulo === 0) {
    return value
  }

  if (modulo < intervalHalf) {
    return value - modulo
  }
  return value - modulo + interval
}

export const scrDesktops = () => {
  Breakpoint.init()
  return Breakpoint.is('lg') || Breakpoint.is('md')
}

export const scrDevices = () => {
  Breakpoint.init()
  return Breakpoint.is('sm') || Breakpoint.is('xs')
}

export const scrPhones = () => {
  Breakpoint.init()
  return Breakpoint.is('xs')
}

export const isExpEditor = () => {
  return document.body.classList.contains('exp-editor')
}

export const iniTooltips = (element) => {
  const tooltips = Array.from(
    element.querySelectorAll('[data-bs-toggle="tooltip"]')
  )

  tooltips.map((i) => {
    new Tooltip(i)
  })
}

export const getRandomGradient = () => {
  const max = constants.gradients.length
  const index = Math.floor(Math.random() * Math.floor(max))

  const { start, finish } = constants.gradients[index]

  return `linear-gradient(135deg, ${start} ${finish})`
}

export const getReferrer = () => {
  const referrer = document.referrer

  if (!referrer) {
    return '/'
  }

  try {
    const referrerUrl = new URL(referrer)
    const documentUrl = new URL(document.URL)

    if (referrerUrl.host !== documentUrl.host) {
      return '/'
    }

    return referrer
  } catch (e) {
    return '/'
  }
}

export const getSitecoreField = (value) => {
  return document.querySelector(`[data-sc-field-name="${value}"]`)
}

export const isNumeric = (str) => {
  if (typeof str === 'number') {
    return true
  }

  // we only process strings!
  if (typeof str !== 'string') {
    return false
  }
  // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  // ...and ensure strings of whitespace fail
  return !isNaN(str) && !isNaN(parseFloat(str))
}

export const getLocaleFromLangAttr = () => {
  const { lang, locale } = constants
  const langAttr = document.documentElement.lang
  let res
  switch (langAttr) {
    case lang.el:
      res = locale.el
      break
    default:
      res = locale.en
  }
  return res
}

export const makeId = (ln) => {
  const len = ln ? ln : 10
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < len; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const youtubeApi = () => {
  const tag = document.createElement('script')

  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

export const getRecordGenres = (genersIds, genres) => {
  return genersIds.map((genre) => {
    return genres.find((item) => {
      if (item.id === genre) {
        return item.id
      }
      return false
    }).text
  })
}

export const getRecordGenresWithDislay = (genresList, genre) => {
  return [genresList.value.find((item) => item.value === genre)?.display]
}

export const getLocale = () => {
  return document.documentElement.lang
}

export const removeDiacritics = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const getHeaderHeight = () => {
  return jQuery('.header__layer').length
    ? jQuery('.header__layer').outerHeight()
    : 0
}

export const moveWindowToObj = (obj, offsetPixels, callback) => {
  if (!jQuery(obj).length) {
    return
  }

  const offset = !offsetPixels ? 0 : offsetPixels
  let objToPos = 0
  if (obj.is(':hidden')) {
    obj.show()
    objToPos = jQuery(obj).offset()
    obj.hide()
  } else {
    objToPos = jQuery(obj).offset()
  }

  let headerH = getHeaderHeight()
  headerH = headerH ? headerH : 0

  jQuery('html,body').clearQueue()
  jQuery('html,body').stop()
  jQuery('html,body')
    .stop()
    .animate({ scrollTop: objToPos.top + offset - headerH }, 400, function () {
      if (callback) {
        if (typeof callback === 'function') {
          callback()
        }
      }
    })
}

const checkCaptchaLoaded = (maxRetries = 10) => {
  let retryCount = 0

  return new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      // CAPTCHA is loaded, resolve the Promise
      resolve()
    } else if (retryCount < maxRetries) {
      // CAPTCHA not loaded, increment the retry count and recursively check
      retryCount = retryCount + 1
      setTimeout(() => {
        checkCaptchaLoaded(maxRetries).then(resolve).catch(reject)
      }, 1000)
      // Adjust the timeout duration as needed
    } else {
      // Maximum number of retries reached, reject the Promise
      reject('CAPTCHA not loaded after maximum retries.')
    }
  })
}

export const checkCaptcha = (callback, failCallback) => {
  checkCaptchaLoaded(10)
    .then(() => {
      // Perform actions once CAPTCHA is loaded
      //console.log('CAPTCHA loaded')
      if (typeof callback === 'function') {
        callback()
      }
      return true
    })
    .catch((error) => {
      // Handle the case where CAPTCHA is not loaded after the specified number of retries
      console.log(error)
      if (typeof failCallback === 'function') {
        failCallback()
      }
      return false
    })
}

export const setLogin = (loggedIn) => {
  if (loggedIn) {
    jQuery('.header').addClass('header--loggedin')
  } else {
    jQuery('.header').removeClass('header--loggedin')
  }
}

export const updateDomAvatarImages = (img) => {
  jQuery('.header__user__img').attr('src', img)
  jQuery('.b-block__user-el__avatar').find('img').attr('src', img)
}

export const updateUserName = (firstName, lastName, fullName) => {
  jQuery('.header__user__first-name').text(firstName)
  jQuery('.b-block__user-el__avatar').find('img').attr('alt', fullName)
  jQuery('.b-block__user-el__name').text(firstName)
  jQuery('.b-block__user-el__lastname').text(lastName)
  jQuery('.header__user__img').attr('alt', fullName)
}

export const updateUserDisplay = ({ img, firstName, lastName, fullName }) => {
  setLogin(true)

  if (img && typeof img === 'string') {
    updateDomAvatarImages(img)
  } else {
    console.warn('img is empty or invalid')
  }

  if (firstName && typeof firstName === 'string') {
    updateUserName(firstName, lastName, fullName)
  } else {
    console.warn('firstName is empty or invalid')
  }
}

export const readVerificationToken = () => {
  const inpt = jQuery('[name="__RequestVerificationToken"')
  return inpt.length ? inpt.val() : ''
}

export const updateVerificationToken = (newToken) => {
  const inpt = jQuery('[name="__RequestVerificationToken"')
  if (newToken && jQuery(newToken.data).length) {
    const newVal = jQuery(newToken.data).val()

    if (newVal) {
      inpt.val(newVal)
      return true
    }
  }

  console.warn('Token not valid!')
  return false
}

export const roundToDigits = (price) => {
  // return parseFloat(price).toFixed(2)
  return parseFloat(price).toLocaleString(document.documentElement.lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const axiosConfig = {
  headers: {
    'x-language': document.documentElement.lang,
  },
}
